// Charte de ZERO MAZE (docs/BRAND.md#colours) : la même structure que ZERO SLANG, quatre couleurs de base et six accents,
// chacun avec un rôle fixe dans le jeu. Source unique des valeurs : index.html (variables CSS de :root), vite.config.js
// (manifeste) et le canvas s'en servent ; un test (tests/unit/brand.test.js) vérifie qu'index.html les reprend à l'identique.
export const palette = Object.freeze({
  bg: '#0b0f24',     // Fond : page, labyrinthe, barre du navigateur
  card: '#161b3a',   // Panneaux : scoreboard, fenêtres, rouleaux
  text: '#f2f5ff',   // Texte
  muted: '#8e98c2',  // Texte secondaire, libellés, mentions légales
  cyan: '#3de0ff',   // Murs du labyrinthe, marque, niveau, focus
  violet: '#9d7bff', // Fin du dégradé de la marque, boutons du son
  orange: '#ff9f43', // La souris (le joueur) : ses traces, son halo, son score
  lime: '#c6ff3d',   // Le rat (l'adversaire) : ses traces, ce qu'il voit
  gold: '#ffd23d',   // Le fromage : les points à gagner, le Hall of Fame, les bulles d'aide
  down: '#ff6b6b',   // Danger : défaite, arrêt de la musique, erreur
});

// Emoji sombres que la police du système dessine presque noirs (🎶 : notes noires chez Apple), invisibles sur le fond de nuit :
// partout où ils s'affichent, un halo clair les détoure (dans le labyrinthe : ui/renderer.js ; dans les textes et sur les
// rouleaux : .emoji-halo, ui/dom.js#haloClass).
export const HALO_EMOJI = Object.freeze(['🎶']);

// Thème visuel Néon / Moderne
export const gameTheme = Object.freeze({
  title: 'ZERO MAZE',
  // Sprites SVG des emojis qui en ont un (Noto Emoji, Apache 2.0, sauf le rat dessiné pour le projet :
  // voir public/emoji/NOTICE.md). Les autres personnages et actions du bandit manchot (data/cast.js)
  // sont dessinés par la police emoji du système, qui sert aussi de secours le temps du chargement.
  // scale : taille relative ; facesLeft : le sprite regarde à gauche, retourné quand il va à droite.
  sprites: {
    '🐭': { src: '/emoji/mouse-face.svg' },
    '🐀': { src: '/emoji/rat.svg', scale: 1.3, facesLeft: true }, // large et bas : agrandi pour peser autant que la souris
    '🧀': { src: '/emoji/cheese.svg' },
  },
  wallColor: palette.cyan,         // Murs néon
  pathColor: palette.lime,         // Traces de pattes de l'adversaire
  mousePrintColor: palette.orange, // Traces de pattes du joueur
  canvasBg: palette.bg,            // Identique au fond de l'appli
  touchGlowColor: palette.orange,  // Halo autour du joueur pendant un glissement tactile
  hintGlowColor: palette.gold,     // Halo du personnage désigné par la bulle d'aide
  sightColor: palette.lime,        // Cases vues par l'adversaire, cache-cache
  haloEmoji: HALO_EMOJI,           // Emoji détourés d'un halo clair
  emojiHaloColor: palette.text,    // Couleur de ce halo
  warnWallColor: palette.gold,     // Murs à l'annonce de l'arrêt de la musique, statues musicales
  freezeWallColor: palette.down,   // Murs pendant l'arrêt de la musique
});
